/**
 * Wrap console, do logs depend on applicationDebug constant
 *
 * @summary Wrap console, do logs depend on applicationDebug constant
 * @version 0.1
 * @since 0.1
 * @author Sergii Kshenskyi <sergii.kshenskyi@aofl.com>
 * @module core_client_library/js/aofl-js/0-6-0/aofl-log/0-1
 */
define([/* eslint-disable */
  'core_client_library/js/aofl-js/0.6.0/app/app'
  /* eslint-enable */
], function(app) {
  'use strict';

  app.registerFactory('aoflLog', [
    'applicationDebug',
    function(applicationDebug) {
      var log = {
        assert: function() {},
        clear: function() {},
        count: function() {},
        debug: function() {},
        dir: function() {},
        dirxml: function() {},
        error: function() {},
        group: function() {},
        groupCollapsed: function() {},
        groupEnd: function() {},
        info: function() {},
        log: function() {},
        markTimeline: function() {},
        memory: function() {},
        profile: function() {},
        profileEnd: function() {},
        table: function() {},
        time: function() {},
        timeEnd: function() {},
        timeStamp: function() {},
        timeline: function() {},
        timelineEnd: function() {},
        trace: function() {},
        warn: function() {}
      };

      if (!console || !console.__proto__) { // if IE lte 9, closed console IE9 not exists
        return log;
      }

      var keys = Object.getOwnPropertyNames(console); // webkit

      if (!keys.length) {
        keys = Object.keys(console.__proto__); // moz
      }

      return keys.reduce(function(log, key) {
        if (typeof console[key] === 'function') {
          log[key] = function() {
            if (applicationDebug) {
              console[key].apply(console, arguments);
            }
          };
        } else {
          log[key] = console[key];
        }
        return log;
      }, log);
    }
  ]);
});
